import { Routes } from '@angular/router'

import { ValidationLayout } from '@layouts/validation-layout'
import { paymentGuard } from '@guards/payment'

import { AppComponent } from './app.component'

export const routes: Routes = [
	{
		path: 'validation',
		component: ValidationLayout,
		children: [
			{
				path: ':requestPointUuid',
				loadComponent: () => import('@pages/validation-page').then((c) => c.ValidationPage),
			},
		],
	},
	{
		path: '',
		component: AppComponent,
		children: [
			{
				path: '',
				loadComponent: () => import('@pages/home').then((c) => c.HomePage),
			},
			{
				path: 'ticket/:locationUUID/:ticket',
				loadComponent: () => import('@pages/ticket').then((c) => c.TicketPage),
			},
			{
				path: 'payment',
				canActivate: [paymentGuard],
				loadComponent: () => import('@pages/payment').then((c) => c.PaymentPage),
			},
			{
				path: 'windcave-payment',
				loadComponent: () => {
					return import('@pages/windcave-payment').then((c) => c.WindcavePaymentPage)
				},
			},
			{
				path: 'common/:type',
				loadComponent: () => import('@pages/common').then((c) => c.CommonPage),
			},
			{
				path: '**',
				pathMatch: 'full',
				redirectTo: '/',
			},
		],
	},
]
